import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  findSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/report/newPlan/selectSchemeList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
